import { render, staticRenderFns } from "./kplh-approver.vue?vue&type=template&id=1751d360&"
import script from "./kplh-approver.vue?vue&type=script&lang=js&"
export * from "./kplh-approver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports